import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import vuetify from './plugins/vuetify'
import VueMeta from 'vue-meta'
import store from './store'
import firebase from 'firebase/compat/app'
import 'firebase/compat/firestore'
import 'firebase/compat/analytics'
import 'firebase/compat/auth'
import 'firebase/compat/app-check'
import firebaseConfig from './services/firebase'
import VueSocialSharing from 'vue-social-sharing'
import VueFab from 'vue-float-action-button'
require('./services/errorHandler')

window.axios = require('axios')
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
window.axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('TOKEN_AUTH')}`

firebase.initializeApp(firebaseConfig)
firebase.analytics()
console.log('appVerificationDisabled:', firebase.auth().settings.appVerificationDisabledForTesting)
const isLocalhost = window.location.hostname === 'localhost' || 
                    window.location.hostname === '127.0.0.1'

if (isLocalhost) {
  self.FIREBASE_APPCHECK_DEBUG_TOKEN = 'B00BB79C-E21F-4D8F-A23E-6013C99F7CB3'
  // firebase.auth().settings.appVerificationDisabledForTesting = true
}

// const appCheck = firebase.appCheck()
// appCheck.activate(
//   new firebase.appCheck.ReCaptchaV3Provider('6LfCmRktAAAAANrDWTEo0kVe6BZvbCTMBfMZEqzQ'), // 👈 V3, não Enterprise
//   true
// )
Vue.config.productionTip = false
Vue.use(VueSocialSharing)
Vue.use(VueFab)
Vue.use(VueMeta, {
  refreshOnceOnNavigation: true
})

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')